<template>
<div class="order">
    <headerNav title="确认订单" />
    <van-cell center :border="false" class="contact-card" is-link to="/user/address?sourece=1">

        <template v-if="!addressData.receiverState">
            <strong>暂无地址,点击前往添加地址</strong>
        </template>
        <template v-else>
            <strong>{{addressData.receiverName+" "+addressData.receiverMobile}}</strong>
            <!-- <van-tag type="primary"  v-if="addressData.isAuthCard">认证</van-tag>
            <van-tag type="danger" v-if="!addressData.isAuthCard">未认证</van-tag> -->
            <div>{{addressData.receiverState+addressData.receiverCity+addressData.receiverDistrict}}</div>
            <div>{{addressData.receiverAddress}}</div>
        </template>
        <template #icon>
            <van-icon :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon" name="dizhi" />
        </template>
    </van-cell>
    <div style="height:15px;"></div>
    <div class="card" v-for="(product,i) in goodlist" :key="i">
        <product-card :product='product' />
    </div>
    <div style="height:15px;"></div>
    <van-cell-group>
        <van-field v-model="PhoneTradeDto.buyerMessage" label="留言" type="textarea" placeholder="请输入留言" rows="1" autosize />
    </van-cell-group>
    <div style="height:15px;"></div>
    <van-cell-group class="total"  v-if="linkpage.couponMain.coupons && linkpage.couponMain.coupons.length>1">
        <van-cell title="优惠券" is-link :value="linkpage.couponMain.coupons[selectCouponIndex].title" @click="showPicker = true" />
    </van-cell-group>
<van-popup v-model="showPicker" round position="bottom" v-if="linkpage.couponMain.coupons">
  <van-picker
    show-toolbar
    :columns="linkpage.couponMain.coupons"
    @cancel="showPicker = false"
    @confirm="onConfirmcoupon"
    value-key="title"
  />
</van-popup>
    <div style="height:15px;"></div>
    <van-cell-group class="total">
        <van-cell title="商品总额" :value="linkpage.goodsTotalPrice" />
        <van-cell title="运费" :value="linkpage.postFee||'免运费'" />
        <!-- <van-cell title="折扣" value="- 5.00" /> -->
        <van-cell title="实付金额" :value="linkpage.realPayPrice" style="font-weight: 700;" />
    </van-cell-group>

    <div style="height:50px;"></div>
    <van-submit-bar :price="linkpage.realPayPrice*100" button-text="提交订单" label='实付金额：' @submit="onSubmit" :loading="isload" >
        <template #tip v-if="linkpage.isSeaTrade&&!addressData.isAuthCard">
            <div>
                你的收货地址还未认证不支持海外产品, <span @click="gotoaddress()" style="color:blue">修改地址</span>
            </div>
        </template>
    </van-submit-bar>

</div>
</template>

<script>
import request from "../../config/ajax";
import Util from "../../config/Util";
export default {
    data() {
        return {
            type: "add1",
            goodlist: [],
            totalMoney: 0,
            goodMoney: 0,
            payment: 0,
            isload: false,
            linkpage: {
                isFirst: 0,
                IsCar: false,
                realPayPrice: 0,
                skus: [],
                secInfo: {},
                revInfo: {}
            },
            addressData: undefined,
            PhoneTradeDto: {
                buyerNick: '',
                receiverName: '',
                receiverState: '',
                receiverCity: '',
                receiverDistrict: '',
                receiverAddress: '',
                receiverMobile: '',
                buyerMessage: '',
                activeDetailId: '',
                activeId: 0,
                productId: 0,
                productSpecId: 0,
                phoneTradeDetails: []
            },
            showPicker:false,
            selectCouponIndex:0
        }
    },
    created() {
        if (!Util.abp.session.userId) {
            this.$router.push({
                path: "/login/password"
            });
        } else {
            var option = this.$route.query;
            if (option.secid != null && option.secdetailid != null) {
                //表示来自秒杀商品
                this.linkpage.secInfo.OrderActiveId = option.secid;
                this.linkpage.secInfo.ActiveDetailId = option.secdetailid
            }
            if (option.createType == 0) {
                this.linkpage.IsCar = true; //表示订单来自购物车跳转过来的
            }

            var goodinfostr = localStorage.getItem("createorderinfo");
            console.log(goodinfostr);
            this.goodlist = JSON.parse(goodinfostr);
            console.log(this.goodlist);
            this.goodlist.forEach(x => {
                this.linkpage.skus.push({
                    sku: x.sku,
                    num: x.quantity,
                    cartonSize: x.cartonSize
                })
                if (x.isServer) {
                    this.isServer = true;
                }
            })
            console.log(this.linkpage);
            this.getmyAddress();
            if (!this.linkpage.revInfo) {
                this.linkpage.revInfo = {};
            }

            this.abp.event.on("app.UserCreateOrder", x => {
                this.isload = false
                if (x.status != 0) {
                    this.$toast(x.errMsg);
                } else {
                    var tid = x.result;
                    this.$router.push({
                        path: '/pay',
                        query: {
                            tid: tid,
                            code: ''
                        }
                    });
                }
            })

            this.abp.event.on("app.SecCreateOrder", x => {
                this.isload = false
                if (x.status != 0) {
                    this.$toast(x.errMsg);
                } else {
                    var tid = x.result;
                    this.$router.push({
                        path: '/pay',
                        query: {
                            tid: tid,
                            code:''
                        }
                    });
                }
            })
        }

    },
    methods: {
         gotoaddress() {
            this.$router.push({
                name: 'address',
                params: {
                    sourece: 1
                }
            });
        },
        getmyAddress() {
              let id=localStorage.getItem('changeaddress') || 0;
            localStorage.setItem('changeaddress',''); 
            request.post('/api/services/app/PhoneUser/QueryDefaultAddress?id='+id).then(x => {
                this.addressData = x.result;
                this.linkpage.revInfo.receiverState = this.addressData.receiverState;
                this.updateAddress();
            })
        },
        updateAddress() {
            this.linkpage.isFirst = 0;
            this.Async_Linkage();
        },
        //加载地址
        checkaddress(item) {
            this.addressData = item;
            setTimeout(() => {
                this.linkpage.revInfo.receiverState = this.addressData.receiverState;
                this.updateAddress();
            }, 10)
        },
        Async_Linkage() {
            request.post('/api/services/app/PhoneTrade/Async_Linkage', this.linkpage).then(x => {
                this.linkpage = x.result;
                this.linkpage.couponMain.selectCoupon = undefined;
                if (this.linkpage.couponMain.coupons) {
                    this.linkpage.couponMain.coupons = this.linkpage.couponMain.coupons.map(x => {
                        if (x.id != 0) {
                            x.title = x.minSellPrice > 0 ?
                                `满${x.minSellPrice}省${x.price}元` :
                                `无门槛省${x.price}元`;
                        } else {
                            x.title = '不使用优惠券';
                        }

                        return x;
                    })
                    if (this.linkpage.couponMain.selectId >= 0) {
                        this.linkpage.couponMain.selectCoupon = this.linkpage.couponMain.coupons.filter(x => x.id == this.linkpage.couponMain
                            .selectId)[0];

                        //console.log(this.linkpage.couponMain.coupons)
                        this.$forceUpdate();
                    }
                }

                this.linkpage.isFirst++; //方便后续的调用查询更快
            })
        },
        onSubmit() {

            if (!this.addressData.receiverState || !this.addressData.receiverDistrict || !this.addressData.receiverState || !this.addressData.receiverCity || !this.addressData.receiverMobile) {
                this.$toast("请选择个人地址");
                return;
            }

            if(this.linkpage.isSeaTrade&&!this.addressData.isAuthCard)
            {
                this.$toast("您的收货地址还未认证不支持海外产品");
                return;
            }

            let useraddress = this.addressData;

            let currgooodlist = this.goodlist;
            this.PhoneTradeDto.revInfo = {};
            if (this.addressData.receiverName) {
                this.PhoneTradeDto.revInfo.receiverAddress = useraddress.receiverAddress;
                this.PhoneTradeDto.revInfo.receiverCity = useraddress.receiverCity;
                this.PhoneTradeDto.revInfo.receiverDistrict = useraddress.receiverDistrict;
                this.PhoneTradeDto.revInfo.receiverState = useraddress.receiverState;
                this.PhoneTradeDto.revInfo.receiverMobile = useraddress.receiverMobile;
            }
            this.PhoneTradeDto.revInfo.receiverName = useraddress.receiverName || Util.abp.userInfo.dealerName;
            this.PhoneTradeDto.revInfo.buyerNick = Util.abp.userInfo.dealerName;
            this.PhoneTradeDto.revInfo.buyerMessage = this.PhoneTradeDto.buyerMessage;
            this.PhoneTradeDto.revInfo.cardNo=useraddress.cardNo;
            this.PhoneTradeDto.revInfo.isAuthCard=useraddress.isAuthCard;
            this.PhoneTradeDto.revInfo.picPath=useraddress.picPath;
            //console.log(this.PhoneTradeDto.revInfo);
            this.linkpage.revInfo = this.PhoneTradeDto.revInfo;
            this.PhoneTradeDto.phoneTradeDetails = []; //从购物车中取产品
            currgooodlist.forEach(x => {
                this.PhoneTradeDto.phoneTradeDetails.push({
                    sku: x.sku,
                    num: x.quantity
                });
            })
            //从购物车，生成订单
            var url = '/api/services/app/PhoneTrade/Confirm_order';
            // if (this.createType == 1) {
            // 	//立即支付
            // 	url = '/api/services/app/PhoneTrade/OnceCreateOrder';
            // }
            this.isload = true;
            if (this.linkpage.secInfo.orderActiveId != null) {
                url = '/api/services/app/PhoneSecManage/BuyGoods';
                this.PhoneTradeDto.activeId = this.linkpage.secInfo.orderActiveId;
                this.PhoneTradeDto.activeDetailId = this.linkpage.secInfo.activeDetailId;
                this.PhoneTradeDto.sku = this.linkpage.skus[0].sku;
                this.PhoneTradeDto.num = this.linkpage.skus[0].num;
                this.PhoneTradeDto.cartonSize=this.linkpage.skus[0].cartonSize;
                this.PhoneTradeDto.couponRecordId = this.linkpage.couponMain.selectId;
                if (this.linkpage.moneyOffMain.selectId == 1) {
                    this.PhoneTradeDto.MoneyOffDetailId = this.linkpage.moneyOffMain.details[1].moneyOffIds[0] //参与的满减
                }
                setTimeout(() => {
                    request.post(url, this.PhoneTradeDto).then().catch(() => {
                        this.isload = false
                    });
                }, 300)
            } else {
                setTimeout(() => {
                    request.post(url, this.linkpage).then().catch(() => {
                        this.isload = false
                    });
                }, 300)
            }
        },
        bindPickerChange(e) {
            this.linkpage.moneyOffMain.selectId = parseInt(e.target.value)
            this.Async_Linkage();
            // this.$abp.lunrequest.post('/api/services/app/PhoneTrade/Async_Linkage', this.linkpage).then(x => {
            // 	this.linkpage = x.result;
            // 	this.linkpage.isFirst++; //方便后续的调用查询更快
            // })
        },
        bindPickerChangecoupon(e) {
            this.linkpage.couponMain.selectId = this.linkpage.couponMain.coupons[parseInt(e.target.value)].id;
            this.Async_Linkage();
        },
        onConfirmcoupon(e,index){
            this.linkpage.couponMain.selectId=e.id;
            this.Async_Linkage();
            this.selectCouponIndex=index;
            this.showPicker=false
        }

    },
    activated() {
        //根据key名获取传递回来的参数，data就是map
        this.$on('changeaddress', function (data) {
            //console.log('返回触发数据:',data);
            //赋值给首页的附近医院数据模型
            this.checkaddress(data);
        }.bind(this));
    }
};
</script>

<style lang="scss" scoped>
.order {
    font-size: 14px;
    background: #f7f7f7;

    .contact-card::before {
        content: "";
        left: 0;
        right: 0;
        bottom: 0;
        height: 2px;
        position: absolute;
        background: -webkit-repeating-linear-gradient(135deg,
                #ff6c6c 0,
                #ff6c6c 20%,
                transparent 0,
                transparent 25%,
                #3283fa 0,
                #3283fa 45%,
                transparent 0,
                transparent 50%);
        background: repeating-linear-gradient(-45deg,
                #ff6c6c 0,
                #ff6c6c 20%,
                transparent 0,
                transparent 25%,
                #3283fa 0,
                #3283fa 45%,
                transparent 0,
                transparent 50%);
        background-size: 80px;
    }

    .total {
        .van-cell__value {
            color: red;
        }
    }

    .van-submit-bar__bar {
        border-top: 1px solid #f7f7f7;
    }

    .additional {
        .van-cell {
            padding: 0 15px;
            font-size: 12px;
        }

        .van-cell__title {
            flex: 11;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .van-tag {
            line-height: 12px;
            margin-right: 5px;
        }

        .price {
            color: #e93b3d;
            font-size: 10px;

            span {
                font-size: 16px;
            }
        }
    }
}
</style>
